<template>
  <div>
    <!-- BUG-CMSCP_HL-887 【功能+偶现+严重】客户/工单业务类型表单中添加地址类型字段，并添加相关权限后，新建客户/工单时，页面加载太慢，偶现接口无响应； -->
    <CCascader ref="cas" @change="_areaChange" :placehold="fieldData.fieldName"></CCascader>
    <Input
      v-if="fieldData.checkId==1"
      v-model="valInp"
      type="textarea"
      :autosize="{minRows: 3}"
      maxlength="300"
      @on-change="inpChange"
      style="margin-top:5px;"
      class = 'cas-textarea'
      placeholder="请输入详细地址"
    />
  </div>
</template>
<script>
import { filterAreaValue } from '@/assets/utils'
import CCascader from './questionnaire/cascade.vue'
export default {
  props: ['fieldData', 'defaultValue'],
  data() {
    return {
      value1: [],
      valInp: '',
      dataList: [],
      bigData: []
    }
  },
  mounted(){
    console.log('地址类型-',this.defaultValue)
    if(this.defaultValue){
      this.value1 = filterAreaValue(this.defaultValue, 0)
      this.valInp = filterAreaValue(this.defaultValue, 1)
      this.$refs['cas'].setData(this.value1)
    }
  },
  watch: {
    defaultValue(newval,oldValue) {
      console.log(newval,oldValue)
      // 避免死循环
      if (newval && newval != oldValue) {
        this.value1 = filterAreaValue(newval, 0)
        this.valInp = filterAreaValue(newval, 1)
        this.$refs['cas'].setData(this.value1)
      }
    }
  },
  methods: {
    _areaChange(value) {
      this.value1 = value
      this.fieldData.value = this.forArrLen(value).join('/') + '/' + this.valInp
      this.$emit('change', {
        value: this.fieldData.value
      })
    },
    inpChange(e) {
      this.valInp = e.target.value
      let arr = [...this.value1]
      this.fieldData.value = this.forArrLen(arr).join('/') + '/' + this.valInp
      this.$emit('change', {
        value: this.fieldData.value
      })
    },
    forArrLen(arr) {
      // 后面把重复代码优化
      if (arr.length == 0) {
        return ['', '', '']
      } else if (arr.length == 1) {
        return [arr[0], '', '']
      } else if (arr.length == 2) {
        return [arr[0], arr[1], '']
      } else {
        return arr
      }
    }
  },
  components: {
    CCascader
  }
}
</script>
<style scoped lang = 'less'>
.cas-textarea /deep/ .ivu-input{
  line-height:1.5!important;
}
</style>
